import { FaInstagram, FaMagic, FaRegCommentDots, FaRobot, FaTelegramPlane, FaTiktok, FaWhatsapp } from "react-icons/fa";

/* Общее оформление страниц входа и регистрации (левая панель OnboardLayout и элементы формы) */

export const INSTAGRAM_GRADIENT =
  "linear-gradient(45deg, #feda75 0%, #fa7e1e 25%, #d62976 50%, #962fbf 75%, #4f5bd5 100%)";

/** Иллюстрация: логотип Ubee с «наклейками» каналов — WhatsApp, Instagram, Telegram, TikTok и ИИ-агент */
export const AuthIllustration = () => (
  <div className="relative w-[260px] h-[220px] sm:w-[340px] sm:h-[270px]">
    <div
      className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[140px] h-[140px] sm:w-[170px] sm:h-[170px] rounded-[40px] bg-white overflow-hidden rotate-[-6deg]"
      style={{ boxShadow: "0 0 0 8px rgba(255,255,255,0.12), 0 24px 60px rgba(150,47,191,0.45)" }}
    >
      <img src="/media/images/ubee-logo.png" alt="" className="w-full h-full object-cover" />
    </div>
    {/* Telegram — слева сверху */}
    <div className="absolute left-4 top-3 w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#229ED9] flex items-center justify-center shadow-xl rotate-[-8deg]">
      <FaTelegramPlane className="text-white w-6 h-6 sm:w-7 sm:h-7 -ml-0.5" />
    </div>
    {/* WhatsApp — слева снизу */}
    <div className="absolute left-0 bottom-6 w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-[#25d366] flex items-center justify-center shadow-xl rotate-[-10deg]">
      <FaWhatsapp className="text-white w-8 h-8 sm:w-10 sm:h-10" />
    </div>
    {/* Instagram — справа сверху */}
    <div
      className="absolute right-0 top-0 w-14 h-14 sm:w-[68px] sm:h-[68px] rounded-2xl flex items-center justify-center shadow-xl rotate-[8deg]"
      style={{ background: INSTAGRAM_GRADIENT }}
    >
      <FaInstagram className="text-white w-7 h-7 sm:w-9 sm:h-9" />
    </div>
    {/* TikTok — справа снизу */}
    <div
      className="absolute right-2 bottom-8 w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-black flex items-center justify-center shadow-xl rotate-[10deg]"
      style={{ boxShadow: "-2px -2px 0 #25F4EE, 2px 2px 0 #FE2C55, 0 20px 25px -5px rgba(0,0,0,0.3)" }}
    >
      <FaTiktok className="text-white w-6 h-6 sm:w-7 sm:h-7" />
    </div>
    {/* ИИ-агент — снизу по центру */}
    <div className="absolute left-1/2 bottom-0 -translate-x-1/2 w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#e8f9b5] flex items-center justify-center shadow-xl rotate-[12deg]">
      <FaRobot className="text-[#4a2366] w-6 h-6 sm:w-7 sm:h-7" />
    </div>
  </div>
);

export const CHATBOT_FEATURE = {
  icon: <FaRegCommentDots size={18} />,
  title: "Чат-бот на кодовое слово",
  text: "Клиент пишет «цена» в Директ или в комментарии — бот сразу отвечает в Instagram",
};

export const AI_AGENT_FEATURE = {
  icon: <FaRobot size={18} />,
  title: "ИИ-агент",
  text: "Отвечает на вопросы клиентов в WhatsApp и Instagram круглосуточно",
};

export const DEMO_DATA_FEATURE = {
  icon: <FaMagic size={16} />,
  title: "Готовый кабинет",
  text: "Заполним демо-данными: клиенты, лиды и обращения — всё можно сразу посмотреть",
};

/** Список возможностей на левой панели */
export const AuthFeatures = ({ items }) => (
  <ul className="flex flex-col gap-4">
    {items.map((f) => (
      <li key={f.title} className="flex items-start gap-3">
        <span className="shrink-0 w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center text-[#e8f9b5]">
          {f.icon}
        </span>
        <div>
          <div className="font-semibold">{f.title}</div>
          <div className="text-sm text-white/60">{f.text}</div>
        </div>
      </li>
    ))}
  </ul>
);

// Основная кнопка формы
export const PRIMARY_BUTTON_CLASS =
  "w-full flex items-center justify-center gap-3 rounded-xl bg-[#4a2366] px-6 py-4 text-lg font-semibold text-white transition-all hover:bg-[#351a4b] hover:shadow-md disabled:opacity-60 disabled:cursor-wait";

// Второстепенная кнопка — в стиле «Продолжить с Instagram»
export const ALT_BUTTON_CLASS =
  "w-full flex items-center justify-center gap-3 rounded-xl border border-gray-300 bg-white px-6 py-3.5 text-base font-medium text-gray-900 transition-all hover:border-gray-400 hover:shadow-md";


/** Подпись над полем формы */
export const FieldLabel = ({ children }) => (
  <div className="text-sm font-medium text-gray-700 mb-1.5">{children}</div>
);

/** Ошибка формы (ответ сервера) */
export const ErrorBox = ({ children }) => (
  <div className="rounded-xl bg-red-50 border border-red-100 px-4 py-3 text-sm text-red-700">{children}</div>
);
